var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickOutsideHandler,
          expression: "clickOutsideHandler"
        }
      ],
      staticClass: "search-field-d"
    },
    [
      _vm.isMounted
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.notrigger.top",
                  value: _vm.tooltip,
                  expression: "tooltip",
                  modifiers: { notrigger: true, top: true }
                }
              ],
              staticClass: "search-field-d__control"
            },
            [
              _c(
                "input-control",
                _vm._b(
                  {
                    ref: "searchInput",
                    attrs: { type: "text" },
                    on: {
                      input: _vm.fieldInputHandler,
                      focus: function($event) {
                        _vm.focused = true
                      },
                      clear: _vm.clear
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prepend",
                          fn: function() {
                            return [
                              _c(
                                "svg",
                                {
                                  staticClass:
                                    "b24-input-control__control-icon",
                                  attrs: { width: "24", height: "24" }
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#Search_24" }
                                  })
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3349466706
                    ),
                    model: {
                      value: _vm.query,
                      callback: function($$v) {
                        _vm.query = $$v
                      },
                      expression: "query"
                    }
                  },
                  "input-control",
                  _vm.input,
                  false
                )
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "tooltip", staticClass: "tooltip-description _input" }, [
        _c("p", [_vm._v(_vm._s(_vm.tooltipMessage))])
      ]),
      _vm._v(" "),
      _vm.resultsVisible
        ? _c(
            "div",
            { staticClass: "search-field-d__results _visible" },
            [
              _c("search-results-d", {
                attrs: {
                  list: _vm.listData,
                  query: _vm.query,
                  message: _vm.message
                },
                on: { select: _vm.resultsSelectHandler }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }